import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

interface InputProps {
	isError: boolean;
	value: string;
}

const Wrapper = styled('div')`
	flex: 0 1 460px;
	margin-left: 10px;
	margin-right: auto;

	form {
		margin-right: 20px;
	}
`;

const Input = styled('input')`
	box-sizing: border-box;
	width: 100%;
	padding: 8px 5px;
	border: 1px solid ${NewStyleColor.Black};
	outline: 0;
	border-radius: 6px;
	background-color: ${NewStyleColor.Black};
	font-family: HelveticaNeue, sans-serif;
	font-weight: bold;
	font-size: 15px;
	line-height: 17px;
	color: ${NewStyleColor.Blue450};
	-webkit-appearance: none;

	${({ isError, value }: InputProps) => (isError || !value) && `border-color: ${NewStyleColor.Red100};`}

	&:focus {
		border-color: ${({ isError, value }: InputProps) => (isError || !value)
			? `${NewStyleColor.Red100}`
			: 'currentColor'
		};
	}

	::-ms-clear {
		display: none;
	}
`;

export {
	Wrapper,
	Input,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Title/styles.ts